import { defineMessages } from 'react-intl';

export default defineMessages({
    noCoverage: {
        id: 'e1p.policychangeeu.components.No Coverages',
        defaultMessage: 'No Coverages'
    },
    noneSelected: {
        id: 'e1p.policychangeeu.components.None Selected',
        defaultMessage: 'None Selected'
    },
    selectedValue: {
        id: 'e1p.policychangeeu.components.The value must be between',
        defaultMessage: 'The value must be between {minValue} and {maxValue}'
    },
    minValue: {
        id: 'e1p.policychangeeu.components.The minimum allowed value is',
        defaultMessage: 'The minimum allowed value is {minValue}'
    },
    maxValue: {
        id: 'e1p.policychangeeu.components.The maximum allowed value is',
        defaultMessage: 'The maximum allowed value is {maxValue}'
    },
    updatingSelection: {
        id: 'e1p.policychangeeu.components.Updating selection...',
        defaultMessage: 'Updating selection...'
    }
});
